import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

/**
 * Hook that returns the count of missions pending admin review.
 * Only activates for admin users. Subscribes to realtime changes.
 */
export function useAdminPendingMissions() {
  const [count, setCount] = useState(0);
  const { getActiveRole, initialized } = useAuth();
  const isAdmin = initialized && getActiveRole() === "admin";

  useEffect(() => {
    if (!isAdmin) return;

    const fetchCount = async () => {
      const { count: c, error } = await supabase
        .from("missions")
        .select("id", { count: "exact", head: true })
        .eq("statut", "en_attente");
      if (!error && c !== null) setCount(c);
    };

    fetchCount();

    const channel = supabase
      .channel("admin-pending-missions")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "missions" },
        () => fetchCount()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [isAdmin]);

  return count;
}
